import "./cookie-baner.scss"

import React, { useEffect, useState } from "react"
import { withCookies } from "react-cookie"
import { Link } from "gatsby"

const Layout = ({ cookies }) => {
  const [cookieBaner, setCookieBaner] = useState("")

  useEffect(() => {
    const isAcceptedCoookie = !!cookies.get("cookie-accept-raska")
    !isAcceptedCoookie && setCookieBaner(true)
  }, [cookies])

  const acceptCookieBaner = () => {
    const promiseSetCookie = new Promise(resolve =>
      resolve(cookies.set("cookie-accept-raska", "active", { path: "/" }))
    )
    promiseSetCookie.then(() => {
      setCookieBaner(false)
    })
  }

  return (
    <div className={`cookie-baner${cookieBaner ? " open" : ""}`}>
      <div className="container-fluid">
        <div className="cookie-baner__wrapper">
          <p>Heimasíðan nýtir farspor.</p>
          <div className="cookie-baner__cta">
            <a
              href="/"
              onClick={e => {
                e.preventDefault()
                acceptCookieBaner()
              }}
            >
              Góðtak
            </a>
            <Link to="/cookies/">Um farspor</Link>
          </div>
        </div>
      </div>
    </div>
  )
}

export default withCookies(Layout)
